var _defs, _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPpt = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 270,
  height: 155
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ppt_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h121v120.999H0z",
  "data-name": "Rectangle 128"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f5f5f5",
  d: "M0 0h270v155H0z",
  "data-name": "Rectangle 18391"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 644106"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ppt_svg__a)",
  "data-name": "Group 233",
  transform: "translate(74.5 17)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M120.5 60.5a60 60 0 1 1-60-60 60 60 0 0 1 60 60",
  "data-name": "Path 2870"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#bcc1c9",
  d: "M60.5 121a60.22 60.22 0 0 1-33.827-10.332A60.67 60.67 0 0 1 4.755 84.049a60.42 60.42 0 0 1 5.578-57.375A60.68 60.68 0 0 1 36.951 4.755a60.42 60.42 0 0 1 57.376 5.578 60.67 60.67 0 0 1 21.918 26.617 60.42 60.42 0 0 1-5.578 57.375 60.67 60.67 0 0 1-26.617 21.92A60.1 60.1 0 0 1 60.5 121m0-120a59.22 59.22 0 0 0-33.266 10.162A59.67 59.67 0 0 0 5.676 37.34a59.42 59.42 0 0 0 5.486 56.426 59.68 59.68 0 0 0 26.179 21.557 59.42 59.42 0 0 0 56.427-5.486 59.67 59.67 0 0 0 21.557-26.177 59.42 59.42 0 0 0-5.486-56.426A59.67 59.67 0 0 0 83.661 5.676 59.1 59.1 0 0 0 60.5 1",
  "data-name": "Path 2871"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#353c3c",
  d: "M92.823 88.9h-68.3a5.044 5.044 0 0 1-4.93-4.93V41.624h1.7V83.94a3.346 3.346 0 0 0 3.262 3.26h68.27Zm4.1-8.676h-64.21a5.043 5.043 0 0 1-4.93-4.93V37.025a5.043 5.043 0 0 1 4.93-4.93h64.22a5.044 5.044 0 0 1 4.93 4.93V75.3a5.044 5.044 0 0 1-4.93 4.93Zm-64.183-1.7h64.162a3.346 3.346 0 0 0 3.261-3.261V37.052a3.346 3.346 0 0 0-3.261-3.261H32.74a3.345 3.345 0 0 0-3.261 3.26v38.211a3.345 3.345 0 0 0 3.266 3.26Z",
  "data-name": "Path 2872"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#772432",
  strokeWidth: 1.7,
  d: "M62.87 58.177h13.58a13.516 13.516 0 0 1-13.58 13.571 13.627 13.627 0 1 1 0-27.253 14.9 14.9 0 0 1 4.515.814Zm16.413-3.983h2.331a13.2 13.2 0 0 0-.354-3.368 13.17 13.17 0 0 0-8.361-8.805l-.684 2.2-3.608 9.973Z",
  "data-name": "Path 656142"
})))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a93439",
  d: "M196 0h74v31h-74z",
  "data-name": "Rectangle 18395"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M222.883 17.437V21H221V10.878h3.3a5.8 5.8 0 0 1 1.757.238 3.4 3.4 0 0 1 1.225.665 2.6 2.6 0 0 1 .711 1.019 3.6 3.6 0 0 1 .231 1.3 3.6 3.6 0 0 1-.245 1.347 2.8 2.8 0 0 1-.735 1.054 3.4 3.4 0 0 1-1.225.686 5.5 5.5 0 0 1-1.722.245Zm0-1.47h1.414a2.8 2.8 0 0 0 .9-.129 1.7 1.7 0 0 0 .637-.371 1.5 1.5 0 0 0 .378-.588 2.3 2.3 0 0 0 .126-.773 2 2 0 0 0-.126-.735 1.45 1.45 0 0 0-.378-.56 1.7 1.7 0 0 0-.637-.354 3 3 0 0 0-.9-.123h-1.414Zm8.75 1.47V21h-1.883V10.878h3.3a5.8 5.8 0 0 1 1.757.238 3.4 3.4 0 0 1 1.223.665 2.6 2.6 0 0 1 .713 1.019 3.6 3.6 0 0 1 .231 1.3 3.6 3.6 0 0 1-.244 1.352 2.8 2.8 0 0 1-.735 1.054 3.4 3.4 0 0 1-1.225.686 5.5 5.5 0 0 1-1.722.245Zm0-1.47h1.414a2.8 2.8 0 0 0 .9-.129 1.7 1.7 0 0 0 .637-.371 1.5 1.5 0 0 0 .378-.588 2.3 2.3 0 0 0 .126-.773 2 2 0 0 0-.126-.735 1.45 1.45 0 0 0-.378-.56 1.7 1.7 0 0 0-.637-.354 3 3 0 0 0-.9-.123h-1.417Zm13.937-5.089v1.547h-3.045V21h-1.883v-8.575h-3.059v-1.547Z",
  "data-name": "Path 656289"
})));
export { SvgPpt as ReactComponent };
export default __webpack_public_path__ + "edd4d9fb5cac305f7cdeb7a503c0706b.svg";